// Componente per la sidebar dell'applicazione

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
    isOpen: boolean;
    toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
    const location = useLocation();
    const [syncDataExpanded, setSyncDataExpanded] = useState(false);

    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <button className="sidebar-toggle" onClick={toggleSidebar}>
                {isOpen ? 'Chiudi' : 'Apri'} Menu
            </button>
            <nav className="sidebar-nav">
                <ul className="sidebar-nav-list">
                    <li className="sidebar-nav-item">
                        <Link
                            to="/calendar"
                            className={`sidebar-nav-link ${location.pathname === '/calendar' ? 'active' : ''}`}
                        >
                            📅 Calendario
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/dashboard"
                            className={`sidebar-nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                        >
                            Dashboard
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/integration"
                            className={`sidebar-nav-link ${location.pathname === '/integration' ? 'active' : ''}`}
                        >
                            Integrazione
                        </Link>
                    </li>
                    
                    {/* Sync Dati di Base - Collapsible Section */}
                    <li className="sidebar-nav-item">
                        <div 
                            className={`sidebar-nav-link sidebar-nav-expandable ${syncDataExpanded ? 'expanded' : ''}`}
                            onClick={() => setSyncDataExpanded(!syncDataExpanded)}
                        >
                            <span>Sync Dati di Base</span>
                            <span className={`sidebar-nav-arrow ${syncDataExpanded ? 'expanded' : ''}`}>▼</span>
                        </div>
                        
                        {syncDataExpanded && (
                            <ul className="sidebar-nav-submenu">
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/hierarchical-structure"
                                        className={`sidebar-nav-sublink ${location.pathname === '/hierarchical-structure' ? 'active' : ''}`}
                                    >
                                        Struttura Gerarchica
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/authority-sync-full"
                                        className={`sidebar-nav-sublink ${location.pathname === '/authority-sync-full' ? 'active' : ''}`}
                                    >
                                        Authorities
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/sites"
                                        className={`sidebar-nav-sublink ${location.pathname === '/sites' ? 'active' : ''}`}
                                    >
                                        Sites
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/hospitals"
                                        className={`sidebar-nav-sublink ${location.pathname === '/hospitals' ? 'active' : ''}`}
                                    >
                                        Hospitals
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/operation-units"
                                        className={`sidebar-nav-sublink ${location.pathname === '/operation-units' ? 'active' : ''}`}
                                    >
                                        Operation Units
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/execution-units"
                                        className={`sidebar-nav-sublink ${location.pathname === '/execution-units' ? 'active' : ''}`}
                                    >
                                        Unità Eroganti
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/doctors"
                                        className={`sidebar-nav-sublink ${location.pathname === '/doctors' ? 'active' : ''}`}
                                    >
                                        Doctors
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/exemptions"
                                        className={`sidebar-nav-sublink ${location.pathname === '/exemptions' ? 'active' : ''}`}
                                    >
                                        Exemptions-Esenzioni
                                    </Link>
                                </li>
                                <li className="sidebar-nav-subitem">
                                    <Link
                                        to="/healthcare-services"
                                        className={`sidebar-nav-sublink ${location.pathname === '/healthcare-services' ? 'active' : ''}`}
                                    >
                                        Prestazioni
                                    </Link>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/diaries"
                            className={`sidebar-nav-link ${location.pathname === '/diaries' ? 'active' : ''}`}
                        >
                            Agende
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/diary-sync"
                            className={`sidebar-nav-link ${location.pathname === '/diary-sync' ? 'active' : ''}`}
                        >
                            Sincronizza Agende
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/bookings"
                            className={`sidebar-nav-link ${location.pathname === '/bookings' ? 'active' : ''}`}
                        >
                            Prenotazioni
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/prescriptions"
                            className={`sidebar-nav-link ${location.pathname === '/prescriptions' ? 'active' : ''}`}
                        >
                            Prescrizioni
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/notifications"
                            className={`sidebar-nav-link ${location.pathname === '/notifications' ? 'active' : ''}`}
                        >
                            Notifiche
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/users"
                            className={`sidebar-nav-link ${location.pathname === '/users' ? 'active' : ''}`}
                        >
                            Utenti
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/sync"
                            className={`sidebar-nav-link ${location.pathname === '/sync' ? 'active' : ''}`}
                        >
                            Sincronizzazione
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/test-endpoints"
                            className={`sidebar-nav-link ${location.pathname === '/test-endpoints' ? 'active' : ''}`}
                        >
                            Test Endpoints
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/profiles"
                            className={`sidebar-nav-link ${location.pathname === '/profiles' ? 'active' : ''}`}
                        >
                            Profili RECUP
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/settings"
                            className={`sidebar-nav-link ${location.pathname === '/settings' ? 'active' : ''}`}
                        >
                            Impostazioni
                        </Link>
                    </li>
                    <li className="sidebar-nav-item">
                        <Link
                            to="/test-routing-simple"
                            className={`sidebar-nav-link ${location.pathname === '/test-routing-simple' ? 'active' : ''}`}
                        >
                            Test Routing Simple
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
